// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@awc/Overrides/Widgets/Footer/FooterContainer";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, layoutContainer, xScreen } from "@awc/XDL/Utilities";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

footerContainerStyles.container = {
    css: css`
        background: ${color("primary")}
    `,
};

footerContainerStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 348px 1fr;
        width: 100%;
        ${layoutContainer}

        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

footerContainerStyles.rightSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-bottom: 16px;

        ${xScreen("lte", "sm")} {
            padding-top: 24px;
        }
    `,
};
footerContainerStyles.linkListSectionContainer = {
    css: css`
        display: flex;
        gap: 32px;
        justify-content: space-between;
        width: 100%;
        padding: 48px 34px 0 48px;
        flex-wrap: wrap;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            padding: 0;
        }
    `,
};

footerContainerStyles.linkListWrapper = {
    css: css`
        max-width: 310px;
        flex: 1;
        .links-wrapper ${StyledTypography} {
            white-space: nowrap;
        }

        .list-link {
            ${TypographyStyle} {
                color: ${color("common.ui1")};
            }
            &:focus ${TypographyStyle}, &:hover ${TypographyStyle} {
                color: ${color("common.ui1")};
                text-decoration: underline;
            }
        }
        .list-title {
            color: ${color("common.ui14")};
        }
    `,
};

footerContainerStyles.bottomSectionContainer = {
    css: css`
        width: 100%;
        max-width: 650px;
        padding-left: 48px;
        display: flex;
        flex-direction: column;
        gap: 16px;

        ${xScreen("lte", "sm")} {
            max-width: unset;
            padding-left: 0;
        }
    `,
};
footerContainerStyles.copyrightText = {
    variant: "p",
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    color: "common.ui1",
    css: css`
        font-style: italic;
        margin: 0;
    `,
};

footerContainerStyles.leftSection = {
    css: css`
        min-width: 348px;
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        gap: 12px;
        padding: 48px 32px 16px 16px;
        max-width: 348px;
        background-color: ${color("primary")};

        .divider {
            border-bottom: 1px solid ${color("common.ui1")};
            padding-bottom: 12px;
            &:empty,
            &:has(> :first-child:empty) {
                padding: 0;
            }
        }
        .privacy-choices-wrapper {
            ${StyledTypography} {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
                color: ${color("common.ui1")};
            }
        }
        .contact-us-wrapper {
            ${StyledTypography} {
                font-size: ${fontConfig.fontSize.xSmall}px;
                line-height: ${fontConfig.lineHeight.singleLinexSmall};
            }
            .list-link {
                svg,
                ${TypographyStyle} {
                    color: ${color("common.ui1")};
                }
                &:focus ${TypographyStyle}, &:hover ${TypographyStyle} {
                    color: ${color("common.ui1")};
                    text-decoration: underline;
                }
            }
            .list-title {
                color: ${color("common.ui14")};
            }
        }
        ${xScreen("lte", "sm")} {
            padding: 24px 46px;
            width: 100%;
            min-width: unset;
            max-width: unset;
            box-shadow: ${color("primary")} 0px 0px 0px 100vmax;
            clip-path: inset(0 -100vmax);
        }
    `,
};
